import React from 'react';
import './Team.css';

import { Heading, TeamItem } from '../../../components';
import { team } from '../../../constants';



const Team = () => {

  return (
    <section className='team'>

      {/* Section heading */}
      <Heading title={'Our Team'} subTitle={'Meet Our Visionaries'} />

      <div className='box-container'>
        {
          // Map over the team array to render each team Memebr
          team.map((item) => {
            return (
              <TeamItem key={item.id} team={item} type="team" /> 
            )
          })
        }
      </div>
    </section>
  )

}

export default Team;